import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AddLearnerOfflineActivityDto, EditLearnerOfflineActivityDto, LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";
import { LearnerOfflineActivityTypes } from "src/app/constants/StoreConstants";

export const AddLearnerOfflineActivity = createAction(
  LearnerOfflineActivityTypes.AddLearnerOfflineActivity,
  props<{ addOfflineActivity: AddLearnerOfflineActivityDto }>()
);

export const AddLearnerOfflineActivitySuccess = createAction(
  LearnerOfflineActivityTypes.AddLearnerOfflineActivitySuccess,
  props<{ result: AddLearnerOfflineActivityDto }>()
);

export const AddLearnerOfflineActivityError = createAction(
  LearnerOfflineActivityTypes.AddLearnerOfflineActivityError,
  props<{ error: HttpErrorResponse }>()
);

export const ResetAddLearnerOfflineActivityResult = createAction(
  LearnerOfflineActivityTypes.ResetAddLearnerOfflineActivityResult,
);

export const EditLearnerOfflineActivity = createAction(
  LearnerOfflineActivityTypes.EditLearnerOfflineActivity,
  props<{ editOfflineActivity: EditLearnerOfflineActivityDto }>()
);

export const EditLearnerOfflineActivitySuccess = createAction(
  LearnerOfflineActivityTypes.EditLearnerOfflineActivitySuccess,
  props<{ result: EditLearnerOfflineActivityDto }>()
);

export const EditLearnerOfflineActivityError = createAction(
  LearnerOfflineActivityTypes.EditLearnerOfflineActivityError,
  props<{ error: HttpErrorResponse }>()
);

export const ResetEditLearnerOfflineActivityResult = createAction(
  LearnerOfflineActivityTypes.ResetEditLearnerOfflineActivityResult,
);

export const GetOfflineActivitySkillSelection = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivitySkillSelection,
  props<{ courseId: number }>()
);

export const GetOfflineActivitySkillSelectionSuccess = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivitySkillSelectionSuccess,
  props<{ result: string[] }>()
);

export const GetOfflineActivitySkillSelectionError = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivitySkillSelectionError,
  props<{ error: any }>()
);

export const GetOfflineActivity = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivity,
  props<{ scormEntryId: number }>()
);

export const GetOfflineActivitySuccess = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivitySuccess,
  props<{ result: LearnerLearningRecord }>()
);

export const GetOfflineActivityError = createAction(
  LearnerOfflineActivityTypes.GetOfflineActivityError,
  props<{ error: HttpErrorResponse }>()
);

export const SetOfflineActivityNavigationRoute = createAction(
  LearnerOfflineActivityTypes.SetOfflineActivityNavigationRoute,
  props<{ route: string}>()
);

export const StoreOfflineActivityNavigationSession = createAction(
  LearnerOfflineActivityTypes.StoreOfflineActivityNavigationSession
);